// Mermaid fences as live diagrams — lazy-loads the library on first use.
// Shared by the brain readers (plane /admin/brain, kit /brain); identical in
// both repos. Use `mermaidCode` as ReactMarkdown's `code` component:
//   <ReactMarkdown components={{ code: mermaidCode }}>{md}</ReactMarkdown>
import React, { useEffect, useState } from 'react';

let ready = null;
async function getMermaid() {
  if (!ready) {
    ready = import('mermaid').then((m) => {
      const mermaid = m.default;
      const dark = typeof window === 'undefined' || !document.documentElement.getAttribute('data-theme') || document.documentElement.getAttribute('data-theme') === 'dark';
      mermaid.initialize({ startOnLoad: false, securityLevel: 'strict', theme: dark ? 'dark' : 'default' });
      return mermaid;
    });
  }
  return ready;
}

let seq = 0;
export default function Mermaid({ code }) {
  const [svg, setSvg] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    let alive = true;
    getMermaid()
      .then((mermaid) => mermaid.render(`brainmmd-${(seq += 1)}`, code))
      .then(({ svg: out }) => { if (alive) setSvg(out); })
      .catch((e) => { if (alive) setErr(e.message); });
    return () => { alive = false; };
  }, [code]);
  if (err) return <pre><code>{code}</code></pre>;
  if (!svg) return <div style={{ color: 'var(--muted)' }}>Rendering diagram…</div>;
  // Mermaid output with securityLevel 'strict' is sanitized SVG.
  // eslint-disable-next-line react/no-danger
  return <div className="mermaid-figure" dangerouslySetInnerHTML={{ __html: svg }} />;
}

export function mermaidCode({ inline, className, children, ...props }) {
  const text = String(children).replace(/\n$/, '');
  if (!inline && /language-mermaid/.test(className || '')) return <Mermaid code={text} />;
  return <code className={className} {...props}>{children}</code>;
}
